var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgKhachHang = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 28.5714C0.666504 12.7919 13.4584 0 29.2379 0H72.0951C87.8746 0 100.667 12.7919 100.667 28.5714V71.4286C100.667 87.2081 87.8746 100 72.0951 100H29.2379C13.4584 100 0.666504 87.2081 0.666504 71.4286V28.5714Z",
    fill: "url(#paint0_linear_449_826)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0963 46.9733C50.8285 46.9465 50.507 46.9465 50.2124 46.9733C43.8374 46.759 38.7749 41.5358 38.7749 35.1072C38.7749 28.5447 44.0785 23.2144 50.6678 23.2144C57.2303 23.2144 62.5606 28.5447 62.5606 35.1072C62.5338 41.5358 57.4713 46.759 51.0963 46.9733Z",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7039 56.8572C31.2217 61.1965 31.2217 68.268 37.7039 72.5805C45.07 77.509 57.1503 77.509 64.5164 72.5805C70.9985 68.2412 70.9985 61.1697 64.5164 56.8572C57.1771 51.9555 45.0967 51.9555 37.7039 56.8572Z",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_449_826",
    x1: 50.6665,
    y1: 0,
    x2: 50.6665,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9A4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26A04"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKhachHang, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/KhachHang.05ff0ac2.svg";
export { ForwardRef as ReactComponent };